
import { Options, Vue } from 'vue-class-component';
import PadronInscripciones from '@/components/PadronInscripciones.vue';
import BusquedaProfesiones from '@/components/profesiones/BusquedaProfesiones.vue';
import BusquedaAsignaciones from '@/components/asignaciones/BusquedaAsignaciones.vue';

@Options({
  components: { PadronInscripciones, BusquedaProfesiones, BusquedaAsignaciones },
  name: 'Home',
})
export default class Home extends Vue {
  tab = 'padron';
  env = process.env.VUE_APP_ENVIRONMENT;
}
